export interface PasswordDTO {
  oldPwd: string;
  newPwd: string;
  newPwdConfirm: string;
}

export const PasswordDTOInit = {
  oldPwd: "",
  newPwd: "",
  newPwdConfirm: "",
};
